// assets
import { ClockCircleOutlined, FileTextOutlined, MailOutlined, TransactionOutlined, UserOutlined } from '@ant-design/icons';

// icons
const icons = {
  ClockCircleOutlined,
  FileTextOutlined,
  MailOutlined,
  TransactionOutlined,
  UserOutlined
};

// ==============================|| MENU ITEMS - ADMINISTRATORS ||============================== //

const administrators = {
  id: 'administrators',
  title: 'Administrators',
  i18nKey: 'menu.administrators',
  type: 'group',
  roles: ['Administrator'],
  children: [
    {
      id: 'admin-users',
      title: 'Users',
      i18nKey: 'menu.users',
      type: 'item',
      url: '/admin/users',
      icon: icons.UserOutlined,
      roles: ['Administrator'],
      breadcrumbs: false
    },
    {
      id: 'admin-email-templates',
      title: 'Email Templates',
      i18nKey: 'menu.emailTemplates',
      type: 'item',
      url: '/admin/email-templates',
      icon: icons.MailOutlined,
      roles: ['Administrator'],
      breadcrumbs: false
    },
    {
      id: 'admin-event-templates',
      title: 'Event Templates',
      i18nKey: 'menu.eventTemplates',
      type: 'item',
      url: '/admin/event-templates',
      icon: icons.FileTextOutlined,
      roles: ['Administrator'],
      breadcrumbs: false
    },
    {
      id: 'admin-scheduled',
      title: 'Queue',
      i18nKey: 'menu.queue',
      type: 'item',
      url: '/admin/scheduled',
      icon: icons.ClockCircleOutlined,
      roles: ['Administrator'],
      breadcrumbs: false
    },
    {
      id: 'admin-transactions',
      title: 'Transactions',
      i18nKey: 'menu.transactions',
      type: 'item',
      url: '/admin/transactions',
      icon: icons.TransactionOutlined,
      roles: ['Administrator'],
      breadcrumbs: false
    }
  ]
};

export default administrators;
